// extracted by mini-css-extract-plugin
module.exports = {"Location":"Location_Location__KaH8S"};